import { Icon } from '@iconify/react/dist/iconify.js'
import React from 'react'
import { Link } from 'react-router-dom'

const ForgotPasswordLayer = () => {
    return (
        <>
            <section className="auth min-vh-100 d-flex justify-content-center align-items-center bg-primary-600">
                <style>
                    {`
                    @keyframes fadeInUp {
                        from { opacity: 0; transform: translateY(20px); }
                        to { opacity: 1; transform: translateY(0); }
                    }
                    .forgot-card {
                        animation: fadeInUp 0.6s ease-out;
                    }
                    .form-control:focus {
                        border-color: #364E3D !important;
                        box-shadow: 0 0 0 3px rgba(54, 78, 61, 0.1) !important;
                        background-color: #fff !important;
                    }
                    input:-webkit-autofill,
                    input:-webkit-autofill:hover, 
                    input:-webkit-autofill:focus, 
                    input:-webkit-autofill:active {
                        -webkit-box-shadow: 0 0 0 30px #f5f6fa inset !important;
                        -webkit-text-fill-color: #111827 !important;
                    }
                    `}
                </style>

                <div
                    className="forgot-card bg-white radius-16 p-32 p-sm-40 shadow-lg text-center mx-3"
                    style={{ maxWidth: "450px", width: "100%" }}
                >
                    <div className="mb-32">
                        <Link to="/" className="d-inline-block mb-24">
                            <img
                                src="/assets/images/logo.png"
                                alt="Logo"
                                style={{ maxHeight: "120px", width: "auto", objectFit: "contain" }}
                            />
                        </Link>
                        <h4 className="mb-12 fw-bold text-dark">Forgot Password</h4>
                        <p className="text-secondary-light text-md">
                            Enter your email to receive a password reset link
                        </p>
                    </div>

                    <form action="#">
                        <div className="icon-field mb-32 text-start">
                            <label className="form-label text-secondary text-sm fw-medium mb-8">
                                Email Address
                            </label>
                            <div className="position-relative">
                                <span className="icon top-50 translate-middle-y start-0 auth-icon-left text-secondary-light">
                                    <Icon icon="mage:email" className="text-xl" />
                                </span>
                                <input
                                    type="email"
                                    className="form-control h-56-px bg-neutral-50 radius-12"
                                    style={{ paddingLeft: "48px" }}
                                    placeholder="Enter Email Address"
                                />
                            </div>
                        </div>

                        <button
                            type="button"
                            className="btn btn-primary btn-lg w-100 radius-12 h-56-px fw-semibold"
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModal"
                            style={{ backgroundColor: "#364E3D", borderColor: "#364E3D" }}
                        >
                            Send Reset Link
                        </button>

                        <div className="mt-24 text-center">
                            <Link to="/sign-in" className="text-primary-600 fw-bold mt-24">
                                <Icon icon="lucide:arrow-left" className="me-8" />
                                Back to Sign In
                            </Link>
                        </div>
                    </form>
                </div>
            </section>

            {/* Modal */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-body p-40 text-center">
                            <div className="mb-32">
                                <Icon icon="solar:letter-bold-duotone" className="text-6xl text-primary-600" />
                            </div>
                            <h6 className="mb-12">Verify your Email</h6>
                            <p className="text-secondary-light text-sm mb-0">
                                Instructions to reset your password have been sent to your email address.
                            </p>
                            <button
                                type="button"
                                className="btn btn-primary btn-lg w-100 radius-12 h-56-px fw-semibold mt-32"
                                style={{ backgroundColor: "#364E3D", borderColor: "#364E3D" }}
                                data-bs-dismiss="modal"
                            >
                                Got it
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ForgotPasswordLayer
